/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Entry_Price__After_StartInputs */

const en_help_center__refund_policy__entry_price__after_start = /** @type {((inputs: Help_Center__Refund_Policy__Entry_Price__After_StartInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Entry_Price__After_StartInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Entry_Price__After_StartInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`After Battle Starts: Once a battle goes live and the timer starts, entry prices are non-refundable. You have committed to participating in the auction.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Entry_Price__After_StartInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "After Battle Starts:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " Once a battle goes live and the timer starts, " }, { type: "markup-start", name: "strong", options: {}, attributes: { "primary": true } }, { type: "text", value: "entry prices are non-refundable" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: ". You have committed to participating in the auction." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "After Battle Starts: Once a battle goes live and the timer starts, entry prices are non-refundable. You have committed to participating in the auction." |
*
* @param {Help_Center__Refund_Policy__Entry_Price__After_StartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__entry_price__after_start = /** @type {((inputs?: Help_Center__Refund_Policy__Entry_Price__After_StartInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Entry_Price__After_StartInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Entry_Price__After_StartInputs, { locale?: "en" }, { strong: { options: {}; attributes: { primary?: true }; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Entry_Price__After_StartInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__entry_price__after_start(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Entry_Price__After_StartInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__entry_price__after_start.parts === "function" ? en_help_center__refund_policy__entry_price__after_start.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__entry_price__after_start(inputs) }]
			})
		}
	)
);